module.exports = __webpack_public_path__ + "img/img-eat-01.a4444bec.png";